import React, { useMemo } from 'react'
import { useTheme } from '@mui/material'
import useFilterContext from 'components/Filter/context'
import { AnimatePresence } from 'framer-motion'
import { CHIP_SIZE } from 'redesign/components/atoms/Chip/constants'
import { FULL_OPACITY, MILISECONS_IN_A_SECOND, ZERO } from 'shared/constants'
import RemovableChipGroup from '../../ChipGroups/RemovableChipGroup'
import { AnimationWrapper, ChipContainer, Container } from './styles'

const SubheaderFilters: React.FC = () => {
  const { getChips, removeChip, openFilterPage } = useFilterContext()
  const { transitions } = useTheme()
  const chips = useMemo(() => getChips(), [getChips])

  const options = useMemo(
    () =>
      chips.map((chip) => ({
        label: chip.label,
        value: chip.filterName,
      })),
    [chips],
  )

  const onDelete = (value: string | number) => {
    const chip = chips.find((foundChip) => foundChip.filterName === value)

    if (chip) {
      removeChip(chip)
    }
  }

  if (!options.length) return null

  return (
    <AnimatePresence>
      <AnimationWrapper
        initial={{ height: ZERO, opacity: ZERO }}
        animate={{ height: 'auto', opacity: FULL_OPACITY }}
        exit={{ height: ZERO, opacity: ZERO }}
        // default duration is in miliseconds so we have to convert it
        transition={{ duration: transitions.duration.shortest / MILISECONS_IN_A_SECOND, ease: 'easeInOut' }}
      >
        <Container>
          <ChipContainer>
            <RemovableChipGroup
              size={CHIP_SIZE.small}
              options={options}
              onDelete={onDelete}
              onClick={() => openFilterPage()}
            />
          </ChipContainer>
        </Container>
      </AnimationWrapper>
    </AnimatePresence>
  )
}

export default SubheaderFilters
